// extracted by mini-css-extract-plugin
export default {"App":"BtnForms_App__AulMa","login__submit":"BtnForms_login__submit__FXVgm"};